import { IConstraintLeaseObligation } from '../../interfaces/iconstraint-lease-obligation';
import { Area } from '../area';
import { Lease } from '../lease';
import { Scenario } from '../scenario';

export class ConstraintLeaseObligationBase {
  ConstraintLeaseObligationId: number;
  ScenarioId: number;
  LeaseId: number | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  AreaId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  Lease?: Lease;
  Scenario?: Scenario;

  constructor(item?: IConstraintLeaseObligation) {
    if (item) {

      this.ConstraintLeaseObligationId = item.ConstraintLeaseObligationId;
      this.ScenarioId = item.ScenarioId;
      this.LeaseId = item.LeaseId;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.AreaId = item.AreaId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.Lease = new Lease(item.Lease);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}